import {InfoPage, RootLayout, RsnButton, Skeleton, useBoolean} from '@raison/ui-kit';
import {Atom, useAtomValue} from 'jotai';
import {AtomWithQueryResult} from 'jotai-tanstack-query';
import React from 'react';
import {logoutCompletely} from '~/entities/user';
import {useAppDispatch} from '~/shared/store';
import {ConfirmAccountClosure} from './ConfirmAccountClosure/ConfirmAccountClosure';

interface Props {
    phoneNumber: Atom<AtomWithQueryResult<string>>;
}

const CloseAccountPage = ({phoneNumber}: Props) => {
    const {data, isSuccess} = useAtomValue(phoneNumber);
    const [successfullyClosed, setSuccessfullyClosed] = useBoolean(false);

    if (successfullyClosed) {
        return <ClosureSuccessScreen />;
    }

    return (
        <RootLayout title='Account closure'>
            <div className='flex h-full px-4 pb-4 pt-6'>
                {isSuccess ? (
                    <ConfirmAccountClosure phoneNumber={data} onSuccess={setSuccessfullyClosed.on} />
                ) : (
                    <CloseAccountPageSkeleton />
                )}
            </div>
        </RootLayout>
    );
};

const CloseAccountPageSkeleton = () => (
    <div className='flex w-full flex-col justify-between'>
        <div className='flex flex-col gap-24'>
            <div>
                <Skeleton width='60%' height={28} />
                <Skeleton width='70%' height={40} />
            </div>
            <div>
                <Skeleton width={31} height={17} />
                <Skeleton width='100%' height={46} />
            </div>
            <div>
                <Skeleton width='60%' height={17} />
                <Skeleton width='65%' height={17} />
            </div>
        </div>
        <Skeleton width='100%' height={52} />
    </div>
);

export default CloseAccountPage;

function ClosureSuccessScreen() {
    const dispatch = useAppDispatch();
    const logout = () => dispatch(logoutCompletely());

    return (
        <InfoPage.Layout symbol={'success'}>
            {{
                center: <InfoPage.Center heading={'Account closed'} details={'Thank you for using Raison.'} />,
                footer: <RsnButton.Primary onClick={logout}>Log out</RsnButton.Primary>,
            }}
        </InfoPage.Layout>
    );
}
